<template>
  <b-container fluid>
    <b-row class="mt-3">
      <b-col></b-col>
      <b-col>
        <b-form @submit="onSubmit" @reset="onReset">
          <b-form-group
            id="exampleInputGroup2"
            horizontal
            label="Application Number*"
            label-size="sm"
            label-for="ipAppNum"
            label-cols="4"
          >
            <b-form-input
              id="ipAppNum"
              type="text"
              lazy-formatter
              v-model="form.ApplicationNumber"
              size="sm"
              placeholder="Application Number to be Changed"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="exampleInputGroup2"
            horizontal
            label="New District *"
            label-size="sm"
            label-for="ipDistrict"
            label-cols="4"
          >
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              required
              size="sm"
              v-model="form.DistrictID"
              class="form-control"
            ></b-select>
          </b-form-group>
          <b-row class="mt-2">
            <b-col style="text-align:center">
              <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
              <b-alert
                :show="showDismissibleAlert"
                dismissible
                @dismissed="showDismissibleAlert=false"
                :variant="variant"
              >{{alertText}}</b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align:right" class="button-wrap">
              <b-button type="submit" variant="primary">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>

      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";

export default {
  components: { Spinner },
  data() {
    return {
      form: {
        ApplicationNumber: "",
        DistrictID: null,
        UserID: null
      },
      districts: [],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false
    };
  },
  methods: {
    onReset(evt) {
      evt.preventDefault();
      this.form.ApplicationNumber = "";
      this.form.DistrictID = null;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      this.form.UserID = userinfo.UserId;
      let promise = apis.changeDistrict(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "District Changed Successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;

            this.form.DistrictID = this.$store.getters.getDistrict;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/ChangeBoard.vue